export const mediaBreakpoints = { xl: 1536, lg: 996, md: 768, sm: 384, xs: 0 };
